/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useAccounts } from '../query/useAccounts';
import { Account } from '../../@types/Account';

const LIMIT_GET_ACCOUNTS = 5;
const DEBOUNCE_TIME_MS = 500;
const MIN_LENGTH_AUTOCOMPLETE = 3;

type useActionAutoComplete = {
  accounts: Account[],
  autoCompleteValue: string,
  onChangeAutoComplete: (value: string) => void,
  loadAccounts: boolean,
};

const useActionAutoComplete = (select: string[]): useActionAutoComplete => {
  const [accountAutocomplete, setAccountAutocomplete] = useState('');
  const {
    isLoading, accounts, setSearchTerm, searchTerm,
  } = useAccounts({
    key: 'accountsFilter',
    limit: LIMIT_GET_ACCOUNTS,
    select,
    exact: {
      accountStatus: 'ACTIVE',
    },
    not: {
      displayName: '',
    },
  });

  const onChangeAutoComplete = (value: string) => {
    if (value.length >= MIN_LENGTH_AUTOCOMPLETE) {
      setAccountAutocomplete(value);
    }

    if (value?.length === 0) {
      setSearchTerm(value);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setSearchTerm(accountAutocomplete);
    }, DEBOUNCE_TIME_MS);

    return () => clearTimeout(delayDebounceFn);
  }, [accountAutocomplete]);

  return {
    accounts,
    autoCompleteValue: searchTerm,
    onChangeAutoComplete,
    loadAccounts: isLoading,
  };
};

export default useActionAutoComplete;
